export default "__VITE_ASSET__4e74bac4__"